__turbopack_context__.v({
  "title": "styles-module-scss-module__YWMDDW__title",
});
